import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isFeedbackPending: false,
  isFeedbackBtnEnable: false,
  showMainScreen: false,
  isAgentOnline: false,
  isCallConnected: false,
  reminderRefId: null,
  interationRefId: null,
  slackNotificationSent: false,
  campaignId: null,
  isSidebarSwitchDisable: false,
  isAmeyoErronous: false,
  ameyoExtensionToggleOn: true,
  ameyoManualLoginEmail: '',
  ameyoManualLoginPassword: '',
  disconnectApiLoading: false,
  callId: ''
};
const humanReminderSlice = createSlice({
  name: 'humanReminderSlice',
  initialState,
  reducers: {
    setIsFeedbackPending(state, action) {
      state.isFeedbackPending = action.payload;
    },
    setIsFeedbackBtnEnable(state, action) {
      state.isFeedbackBtnEnable = action.payload;
    },
    setShowMainScreen(state, action) {
      state.showMainScreen = action.payload;
    },
    setIsAgentOnline(state, action) {
      state.isAgentOnline = action.payload;
    },
    setIsCallConnected(state, action) {
      state.isCallConnected = action.payload;
    },
    setReminderRefId(state, action) {
      state.reminderRefId = action.payload;
    },
    setInteractionRefId(state, action) {
      state.interationRefId = action.payload;
    },
    setSlackNotificationSent(state, action) {
      state.slackNotificationSent = action.payload;
    },
    refreshCallData(state, action) {
      state.interationRefId = null;
      state.reminderRefId = null;
      state.isCallConnected = false;
      state.showMainScreen = false;
      state.isFeedbackBtnEnable = false;
      state.isFeedbackPending = false;
      state.slackNotificationSent = false;
    },
    setCampaignId(state, action) {
      state.campaignId = action.payload;
    },
    setIsSidebarSwitchDisable(state, action) {
      state.isSidebarSwitchDisable = action.payload;
    },
    setIsAmeyoErroneous(state, action) {
      state.isAmeyoErronous = action.payload;
    },
    setAmeyoExtensionToggleOn(state, action) {
      state.ameyoExtensionToggleOn = action.payload;
    },
    setManualLoginCreds(state, action) {
      const { email, password } = action.payload;
      state.ameyoManualLoginEmail = email;
      state.ameyoManualLoginPassword = password;
    },
    setDisconnectApiLoading(state, action) {
      state.disconnectApiLoading = action.payload;
    },
    setCallId(state, action) {
      state.callId = action.payload;
    }
  }
});

export const {
  setIsFeedbackPending,
  setIsFeedbackBtnEnable,
  setShowMainScreen,
  setIsAgentOnline,
  setIsCallConnected,
  setReminderRefId,
  setInteractionRefId,
  setSlackNotificationSent,
  refreshCallData,
  setCampaignId,
  setIsSidebarSwitchDisable,
  setIsAmeyoErroneous,
  setAmeyoExtensionToggleOn,
  setManualLoginCreds,
  setDisconnectApiLoading,
  setCallId
} = humanReminderSlice.actions;

export default humanReminderSlice.reducer;
